import { FC } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '@features/ui';
import { CloseIcon } from '@features/ui/icons';
import { useTranslation } from 'react-i18next';

interface RequestDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const RequestDialog: FC<RequestDialogProps> = ({
  open,
  onOpenChange,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80"
          data-slot="sheet-overlay"
        />
        <Dialog.Content className="fixed left-1/2 top-1/2 max-h-[85vh] w-[90vw] max-w-[559px] -translate-x-1/2 -translate-y-1/2 rounded-md bg-[#414141] p-[25px] shadow-[var(--shadow-6)] focus:outline-none data-[state=open]:animate-contentShow z-50">
          <Dialog.Title className="m-0 text-2xl font-medium text-center">
            {t('payoutRequest.popupTitle')}
          </Dialog.Title>
          <div className={'flex flex-col gap-y-5 mb-5 mt-4 gap-y-5'}>
            <Dialog.Description className="text-base leading-normal font-semibold text-center">
              {t('payoutRequest.popupDescription')}
            </Dialog.Description>
          </div>
          <Dialog.Close asChild>
            <Button
              aria-label="Close"
              className="[&_svg]:!size-auto absolute right-2.5 top-2.5 inline-flex size-[25px] appearance-none items-center justify-center rounded-full"
              variant={'ghost'}
              onClick={() => onOpenChange(false)}
            >
              <CloseIcon />
            </Button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
